export default __webpack_public_path__ + "static/media/sales.549f4f4b.png";